import script from "./HeaderView.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderView.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderView.vue?vue&type=style&index=0&id=53ea0ff5&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53ea0ff5"]])

export default __exports__